function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Pen",
  opacity: 1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 1.2,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 526.013 513.496 L 446.328 451.560 L 412.859 375.647 L 430.503 271.071 L 499.972 224.218 L 594.028 201.348 L 673.656 267.651 L 710.747 343.856 L 685.719 449.512 L 620.867 494.260 Z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 1.2,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 526.013 513.496 L 541.541 480.143 L 641.036 438.115 L 628.825 324.868 L 524.403 298.310 L 471.372 392.166 L 541.541 480.143 "
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 1.2,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 412.859 375.647 L 471.486 392.685 "
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 1.2,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 524.403 298.310 L 499.373 223.806 "
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 1.2,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 628.825 324.868 L 673.770 268.170 "
}), /*#__PURE__*/React.createElement("path", {
  opacity: 1,
  fill: "none",
  stroke: "#000000",
  strokeWidth: 1.2,
  strokeOpacity: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M 685.719 449.512 L 639.952 437.809 "
}));

var _ref3 = /*#__PURE__*/React.createElement("style", null, "\n    .face { font: bold 90px sans-serif; }\n  ");

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 530,
  y: 420,
  className: "face",
  transform: "rotate(-20 575 465)"
}, "20");

var SvgD20 = function SvgD20(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.331688in",
    height: "2.440335in",
    viewBox: "407.917816 196.371399 307.782867 322.124268",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgD20, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/D20.fcc58258.svg";
export { ForwardRef as ReactComponent };